import React, { useState, useCallback } from "react";
import { Row, Col, Container, Card } from "react-bootstrap";
import ExchangeSelect from "./ExchangeSelect";
import Navbar from "./Navbar";
import NavbarSmall from "./NavbarSmall";
import { toggleNav } from "../../actions/setting-action";
import { connect, useDispatch, useSelector } from "react-redux";
import "./ContentContainer.scss";
import ContactForm from "../help/ContactForm";
import NewUserTour from "../tour/NewUserTour";
import ProjectTour from "../tour/ProjectTour";


const ContentContainer = (props) => {
  const navExpand = useSelector((state) => state.settings.navExpand);
  const takeTour = useSelector((state) => state.settings.takeTour);
  const startTakeTour = useSelector((state) => state.settings.startTakeTour);
  const newUserIntroPupup = useSelector((state) => state.settings.newUserIntroPupup);
  
  const [showContact, setShowContact] = useState(false);
  const [showTour, setShowTour] = useState(true);

  const toggleExpand = () => props.toggleNav(!navExpand);
  return (
    <div className="content-container">
      <Row noGutters>
        {navExpand ? (
          <Navbar
            url={props.url}
            toggleExpand={toggleExpand}
            showContact={() => setShowContact(true)}
          />
        ) : (
          <NavbarSmall
            url={props.url}
            toggleExpand={toggleExpand}
            showContact={() => setShowContact(true)}
          />
        )}

        <Col className="content-col">
          <ExchangeSelect
            url={props.url}
            title={props.title}
            showExchange={props.showExchange}
          ></ExchangeSelect>
          {props.children}
        </Col>
      </Row>
      <ContactForm show={showContact} onHide={() => setShowContact(false)} />
      {takeTour? <ProjectTour></ProjectTour>:<></> }
      {(newUserIntroPupup && !startTakeTour) ? <NewUserTour setShowTour={setShowTour}></NewUserTour>:<></> }
    </div>
  );
};

export default connect(null, { toggleNav })(ContentContainer);
